import React from 'react';
import PropTypes from 'prop-types';
import Field from '../Field';
import Row from '../Row';
import Col from '../Col';
import isFieldValid from '../../utils/isFieldValid';

export default class GroupField extends React.Component {
  static defaultProps = {
    label: undefined,
    children: null,
  };

  static propTypes = {
    label: PropTypes.string,
    children: PropTypes.node,
  };

  static contextTypes = {
    form: PropTypes.shape({
      layout: PropTypes.oneOf(['vertical', 'horizontal', 'inline']),
    }),
  };

  static childContextTypes = {
    form: PropTypes.shape({
      layout: PropTypes.oneOf(['horizontal']),
    }),
  };

  state = {
    isValid: true,
  };

  getChildContext() {
    return {
      form: {
        layout: 'horizontal',
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.validate(nextProps);
  }

  validate = props => {
    const { children } = props;

    const hasErrors = children.some(child => {
      const { valueField } = child.props;

      if (valueField) {
        return !isFieldValid(valueField);
      }

      return false;
    });

    this.setState({ isValid: !hasErrors });
  };

  render() {
    const { isValid } = this.state;
    const { children, ...props } = this.props;
    const { form } = this.context;

    const ratio = 100 / React.Children.count(children);
    const mode = isValid ? undefined : 'danger';

    return (
      <Field {...props} mode={mode} layout={form.layout}>
        <Row vColSpacing="sm">
          {React.Children.map(children, field => (
            <Col ratio={{ md: ratio }}>{field}</Col>
          ))}
        </Row>
      </Field>
    );
  }
}
